import { useMutation } from '@apollo/client';
import { UPDATE_PICKUP_ROUTE } from '../graphql/mutations/updatePickupRoute';
import { UpdatePickupRouteInput, UpdatePickupRouteResponse } from '../graphql/types/PickupRouteTypes';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export const useUpdatePickupRoute = () => {
  const { t } = useTranslation();
  const [updatePickupRoute, { loading, error }] = useMutation<
    UpdatePickupRouteResponse,
    { input: UpdatePickupRouteInput }
  >(UPDATE_PICKUP_ROUTE);

  const updateRoute = async (input: UpdatePickupRouteInput) => {
      try {
      const response = await updatePickupRoute({
        variables: { input },
      });
      
      if (response.data?.updatePickupRoute) {
        return response.data.updatePickupRoute;
      } else {
        throw new Error(t('pickup.pickupTask.messages.failedToUpdateRoute') || '');
      }
    } catch (err: any) {
      console.error('Error updating pickup route:', err);
      const errorMessage = err.message || t('pickup.pickupTask.messages.failedToUpdateRoute') || '';
      message.error(errorMessage);
      throw err;
    }
  };

  return {
    updateRoute,
    loading,
    error,
  };
};
